<template>
  <div>
    <img src="@/assets/tarjeta_servicios_tallerCRM.jpg" style="width: 100%" />
    <p class="tituloTarjeta">TALLER CRM</p>

    <ul style="list-style-type: disc">
      <li>Entrega de partes de accidente en el Taller.</li>
      <li>Peritación inmediata hecha por peritos presenciales en 24 horas.</li>
      <li>Recepción del vehículo 24 horas los 365 días del año.</li>
      <li>Recogida y entrega del vehículo (según proximidad).</li>
      <li>Vehículo de cortesía (consultando disponibilidad).</li>
    </ul>
    <p><br /></p>

    <p class="container-flex">
      <a href="tel:+34 91 594 88 29">
        <button
          class="pure-button botonLlamar"
          title="Pulse el botón para llamar al Taller CRM"
        >
          Llamar
        </button>
      </a>

      <a href="http://www.crmondejar.com/" target="_blank" class="link">
        <button class="pure-button botonLlamar">Infórmate</button>
      </a>
    </p>
  </div>
</template>

<script>
export default {
  methods: {
    email() {},
  },
};
</script>

<style lang="scss" scoped>
.container-flex {
  margin-top: 2.5rem;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}

.botonLlamar {
  background-color: $colorMMT;
  color: white;
  font-weight: bold;
  width: 9rem;
  border: 0.15rem solid;
  border-radius: 0.5rem;
  text-align: center;
}

.link {
  color: $colorMMT;
  font-weight: 460;
  margin-right: 3rem;
}
</style>
